import { useCallback, useState } from "react";
import type { OtpChannel } from "@codway-dev/shared";
import { OtpConfigService } from "../services/otp-config.service";

interface OtpTestSendState {
  sending: boolean;
  verifying: boolean;
  error: string | null;
  requestId: string | null;
  channelUsed: OtpChannel | null;
  actualCostUsd: number | null;
  verified: boolean;
}

const initialState: OtpTestSendState = {
  sending: false,
  verifying: false,
  error: null,
  requestId: null,
  channelUsed: null,
  actualCostUsd: null,
  verified: false,
};

export function useOtpTestSend() {
  const [state, setState] = useState<OtpTestSendState>(initialState);
  const { requestId } = state;

  const sendTest = useCallback(async (phone: string) => {
    setState({ ...initialState, sending: true });
    try {
      const result = await OtpConfigService.sendTestOtp(phone);
      setState({
        ...initialState,
        requestId: result.request_id,
        channelUsed: result.channel_used,
        actualCostUsd: result.actual_cost_usd,
      });
    } catch (err) {
      setState({
        ...initialState,
        error: err instanceof Error ? err.message : "Error al enviar la prueba",
      });
    }
  }, []);

  const verifyTest = useCallback(
    async (code: string) => {
      if (!requestId) return;
      setState((s) => ({ ...s, verifying: true, error: null }));
      try {
        await OtpConfigService.verifyTestOtp(requestId, code);
        setState((s) => ({ ...s, verifying: false, verified: true }));
      } catch (err) {
        setState((s) => ({
          ...s,
          verifying: false,
          error:
            err instanceof Error ? err.message : "Error al verificar el código",
        }));
      }
    },
    [requestId]
  );

  const reset = useCallback(() => setState(initialState), []);

  return { ...state, sendTest, verifyTest, reset };
}
